import { TransitTimesAnalyticsActionTypes } from './constants';

export const INIT_STATE = {
    errorGetAverageDomesticQuotedDays: null,
    loadingAverageDomesticQuotedDays: false,
    averageDomesticQuotedDays: null,
    errorGetAverageDomesticActualDays: null,
    loadingAverageDomesticActualDays: false,
    averageDomesticActualDays: null,
    errorGetTransitTimesByServiceLevel: null,
    loadingTransitTimesByServiceLevel: false,
    transitTimesByServiceLevel: null,
    errorGetTransitTimesByTimeframe: null,
    loadingTransitTimesByTimeframe: false,
    transitTimesByTimeframe: null,
    errorGetTransitTimesSummary: null,
    loadingTransitTimesSummary: false,
    transitTimesSummary: null,
};

type TransitTimesAnalyticsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    errorGetAverageDomesticQuotedDays?: null,
    loadingAverageDomesticQuotedDays: Boolean,
    averageDomesticQuotedDays: any,
    errorGetAverageDomesticActualDays?: null,
    loadingAverageDomesticActualDays: Boolean,
    averageDomesticActualDays: any,
    errorGetTransitTimesByServiceLevel?: null,
    loadingTransitTimesByServiceLevel: Boolean,
    transitTimesByServiceLevel: any,
    errorGetTransitTimesByTimeframe?: null,
    loadingTransitTimesByTimeframe: Boolean,
    transitTimesByTimeframe: any,
    errorGetTransitTimesSummary?: null,
    loadingTransitTimesSummary: Boolean,
    transitTimesSummary: any,
};

const TransitTimesAnalytics = (state: State = INIT_STATE, action: TransitTimesAnalyticsAction): any => {
    switch (action.type) {
        case TransitTimesAnalyticsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_QUOTED_DAYS: {
                    return { ...state, loadingAverageDomesticQuotedDays: false, averageDomesticQuotedDays: action.payload.data };
                }
                case TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_ACTUAL_DAYS: {
                    return { ...state, loadingAverageDomesticActualDays: false, averageDomesticActualDays: action.payload.data };
                }
                case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_SERVICE_LEVEL: {
                    return { ...state, loadingTransitTimesByServiceLevel: false, transitTimesByServiceLevel: action.payload.data };
                }
                case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_TIMEFRAME: {
                    return { ...state, loadingTransitTimesByTimeframe: false, transitTimesByTimeframe: action.payload.data };
                }
                case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_SUMMARY: {
                    return { ...state, loadingTransitTimesSummary: false, transitTimesSummary: action.payload.data };
                }
                default:
                    return { ...state, loadingAverageDomesticQuotedDays: false, loadingAverageDomesticActualDays: false, loadingTransitTimesByServiceLevel: false, loadingTransitTimesByTimeframe: false, loadingTransitTimesSummary: false };
            }

        case TransitTimesAnalyticsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_QUOTED_DAYS: {
                    return { ...state, loadingAverageDomesticQuotedDays: false, errorGetAverageDomesticQuotedDays: action.payload.error };
                }
                case TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_ACTUAL_DAYS: {
                    return { ...state, loadingAverageDomesticActualDays: false, errorGetAverageDomesticActualDays: action.payload.error };
                }
                case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_SERVICE_LEVEL: {
                    return { ...state, loadingTransitTimesByServiceLevel: false, errorGetTransitTimesByServiceLevel: action.payload.error };
                }
                case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_TIMEFRAME: {
                    return { ...state, loadingTransitTimesByTimeframe: false, errorGetTransitTimesByTimeframe: action.payload.error };
                }
                case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_SUMMARY: {
                    return { ...state, loadingTransitTimesSummary: false, errorGetTransitTimesSummary: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_QUOTED_DAYS:
            return { ...state, loadingAverageDomesticQuotedDays: true, averageDomesticQuotedDays: null };
        case TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_ACTUAL_DAYS:
            return { ...state, loadingAverageDomesticActualDays: true, averageDomesticActualDays: null };
        case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_SERVICE_LEVEL:
            return { ...state, loadingTransitTimesByServiceLevel: true, transitTimesByServiceLevel: null };
        case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_TIMEFRAME:
            return { ...state, loadingTransitTimesByTimeframe: true, transitTimesByTimeframe: null };
        case TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_SUMMARY:
            return { ...state, loadingTransitTimesSummary: true, transitTimesSummary: null };
        default:
            return { ...state };
    }
};

export default TransitTimesAnalytics;
